export const stylePrefix = 'formily-vant'
export const vantStylePrefix = 'van'
export const dictList = {
  gasLocation: 'GAS_MONITOR_POINT_LOCATION',
}
